module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1856054"
    }
  }, [_c('b', [_vm._v("CALDO VERDE")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1856754"
    }
  }, [_c('b', [_c('i', [_vm._v("In Portugal, this delicious soup gets its rich green color from finely shredded Galician cabbage, which is sold in the outdoor markets. Kale, readily available in supermarkets, makes a fine substitute. If you like, sprinkle the soup with ½ cup finely chopped fully cooked spicy smoked sausage, such as linguiça or chorizo.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1860154"
    }
  }, [_c('b', [_vm._v("Prep: 15 minutes Cook: 40 to 45 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1860654"
    }
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1860954"
    }
  }, [_vm._v("1 large onion (12 ounces), chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1861254"
    }
  }, [_vm._v("3 garlic cloves, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1861554"
    }
  }, [_vm._v("2½ pounds all-purpose potatoes (8 medium), peeled and cut into 2-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1863054"
    }
  }, [_vm._v("2 cans (14½ ounces each) chicken broth or 3½ cups Chicken Broth")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1865354"
    }
  }, [_vm._v("3 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1865654"
    }
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1865954"
    }
  }, [_vm._v("¼ teaspoon coarsely ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1866954"
    }
  }, [_vm._v("1 pound kale, tough stems and veins trimmed and leaves very thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1867754"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 5-quart Dutch oven, heat oil over medium heat. Add onion and garlic; cook until onion is golden, about 10 minutes. Add potatoes, broth, water, salt, and pepper; heat to boiling over high heat. Reduce heat; cover and simmer until potatoes are tender, about 20 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1870154"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Mash potatoes in broth, keeping potatoes lumpy.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1870854"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Stir in kale; simmer, uncovered, until kale is tender, 5 to 8 minutes. Makes about 10 cups or 5 main-dish servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1872954"
    }
  }, [_vm._v("Each serving: About 251 calories, 7g protein, 41g carbohydrate, 7g total fat (1g saturated), 0mg cholesterol, 1,187mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e55111f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c50_r1.vue
// module id = 216
// module chunks = 0